"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("./constants");
var UniversalHeaderUtils = {
  createCookie: function createCookie(name, value, minutes) {
    var expires = '';
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=".concat(date.toGMTString());
    }
    document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=/");
  },
  generateNavigationSection: function generateNavigationSection() {
    var mobileDataInsideLeftPane = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var menuSection = {
      title: '',
      data: []
    };
    var navigations = mobileDataInsideLeftPane.filter(function (d) {
      return d.type === _constants.HEADER_COMPONENTS.NAVIGATION;
    });
    if (navigations.length === 0) {
      return menuSection;
    }
    navigations.forEach(function (nav) {
      var isCallback = typeof nav.callback === 'function';
      menuSection.data.push({
        iconLeft: nav.iconName,
        label: nav.label,
        value: nav.id,
        redirectUrl: isCallback ? '' : nav.redirectUrl,
        newTab: nav.newTab,
        onClick: isCallback ? nav.callback : function () {}
      });
    });
    return menuSection;
  },
  generateLocaleCurrencyNavigationSection: function generateLocaleCurrencyNavigationSection() {
    var mobileDataInsideLeftPane = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var defaultLoc = arguments.length > 1 ? arguments[1] : undefined;
    var defaultCurr = arguments.length > 2 ? arguments[2] : undefined;
    var onLocaleMenuClick = arguments.length > 3 ? arguments[3] : undefined;
    var onCurrencyMenuClick = arguments.length > 4 ? arguments[4] : undefined;
    var localeIcon = arguments.length > 5 ? arguments[5] : undefined;
    var currencyIcon = arguments.length > 6 ? arguments[6] : undefined;
    var translations = arguments.length > 7 ? arguments[7] : undefined;
    var showLocale = arguments.length > 8 ? arguments[8] : undefined;
    var showCurrency = arguments.length > 9 ? arguments[9] : undefined;
    var menuSection = {
      title: '',
      data: []
    };
    var navigations = mobileDataInsideLeftPane.filter(function (d) {
      return d.type === _constants.HEADER_COMPONENTS.LOCALE_CURRENCY;
    });
    if (navigations.length === 0) {
      return menuSection;
    }
    menuSection.title = translations.settings;
    if (showLocale && defaultLoc) {
      var localeSection = {
        iconLeft: localeIcon,
        label: defaultLoc.longform,
        iconRight: 'ChevronRightIcon',
        onClick: onLocaleMenuClick,
        value: defaultLoc.default
      };
      menuSection.data.push(localeSection);
    }
    if (showCurrency && defaultCurr) {
      var currencySection = {
        iconLeft: currencyIcon,
        label: "".concat(defaultCurr.shortSymbol, " ").concat(defaultCurr.longform),
        iconRight: 'ChevronRightIcon',
        onClick: onCurrencyMenuClick,
        value: defaultCurr.shortform
      };
      menuSection.data.push(currencySection);
    }
    return menuSection;
  },
  generateMobileDropdownSection: function generateMobileDropdownSection(recommendedListData, listData, type, translations, color) {
    var dropdownSections = [];
    var hasRecommendation = recommendedListData && typeof recommendedListData !== 'undefined';
    if (hasRecommendation) {
      var _headerLabel = '';
      if (type === _constants.LOCALE_LABEL) {
        _headerLabel = translations.popularLocale;
      } else if (type === _constants.CURRENCY_LABEL) {
        _headerLabel = translations.popularCurrency;
      }
      var _section = {
        sectionHeaderConfig: {
          sectionTitleColor: color
        },
        optionsConfig: {
          iconColor: color,
          titleColor: color,
          subtitleColor: color
        },
        sectionHeaderLabel: _headerLabel,
        options: []
      };
      recommendedListData.forEach(function (data) {
        if (type === _constants.LOCALE_LABEL) {
          _section.options.push({
            title: data.longform,
            value: data.default
          });
        } else if (type === _constants.CURRENCY_LABEL) {
          _section.options.push({
            title: data.shortform,
            subtitle: data.longform,
            value: data.shortform.toUpperCase()
          });
        }
      });
      dropdownSections.push(_section);
    }
    var headerLabel = '';
    if (type === _constants.LOCALE_LABEL) {
      headerLabel = hasRecommendation ? translations.otherLocale : translations.locale;
    } else if (type === _constants.CURRENCY_LABEL) {
      headerLabel = hasRecommendation ? translations.otherCurrency : translations.currency;
    }
    var section = {
      sectionHeaderConfig: {
        sectionTitleColor: color
      },
      optionsConfig: {
        iconColor: color,
        titleColor: color,
        subtitleColor: color
      },
      sectionHeaderLabel: headerLabel,
      options: []
    };
    listData.forEach(function (data) {
      if (type === _constants.LOCALE_LABEL) {
        section.options.push({
          title: data.longform,
          value: data.default
        });
      } else if (type === _constants.CURRENCY_LABEL) {
        section.options.push({
          title: data.shortform,
          subtitle: data.longform,
          value: data.shortform.toUpperCase()
        });
      }
    });
    dropdownSections.push(section);
    return dropdownSections;
  },
  getData: function getData(arr) {
    if (!arr) {
      return null;
    }
    var dataObject = arr.find(function (el) {
      return el.data;
    });
    if (!dataObject) {
      return null;
    }
    var data = dataObject.data;
    if (!data || !Array.isArray(data)) {
      return null;
    }
    return data;
  }
};
var _default = UniversalHeaderUtils;
exports.default = _default;